export const locale = {
    lang: 'en',
    data: {
        SMART_BANNER: {
            TITLE: 'Get started using our mobile app today!'
        }
    }
};